<div class="columns-container">
    <ng-content />
</div>
